module.exports = __webpack_public_path__ + "static/media/ideco.1e9cbcae.svg";